import React from 'react';
import './styles/globals.scss';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import router from './routes';
import { compose } from './utils/compose';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  compose(
    <React.StrictMode />,
    <React.Suspense fallback={'....'} />,
    <RouterProvider router={router} />,
  ),
);
